import { Web } from "./types.js";
import { SPRest } from "../rest.js";
export { Web, Webs, } from "./types.js";
Reflect.defineProperty(SPRest.prototype, "web", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return Web(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
SPRest.prototype.createBatch = function () {
    return this.web.createBatch();
};
//# sourceMappingURL=index.js.map